var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEtc = function SvgEtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 23,
    height: 20,
    rx: 7,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35c-4.97 0-9-4.925-9-11s4.03-11 9-11",
    stroke: "#222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 35c-4.97 0-9-4.925-9-11s4.03-11 9-11",
    stroke: "#222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 35c4.694 0 8.5-4.925 8.5-11s-3.806-11-8.5-11S20 17.925 20 24s3.806 11 8.5 11Z",
    fill: "#fff",
    stroke: "#222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.451 25.328v.129h1.547v-.129c.006-.82.299-1.201.961-1.594.768-.463 1.266-1.072 1.266-2.039 0-1.447-1.155-2.297-2.79-2.297-1.5 0-2.724.791-2.753 2.438h1.664c.023-.686.533-1.049 1.078-1.055.568.006 1.025.387 1.02.973.005.539-.387.902-.891 1.23-.703.44-1.096.885-1.102 2.344Zm-.176 1.793a.972.972 0 0 0 .985.985c.521 0 .972-.44.972-.985a.978.978 0 0 0-.972-.973.962.962 0 0 0-.985.973Z",
    fill: "#222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13h-8M28 35h-8",
    stroke: "#222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgEtc;